import { RouteObject } from "react-router-dom";
import {
  CONTRACT,
  CONTRACT_EDIT,
  CONTRACT_SEND,
  CONTRACT_DETAILS_TAB,
  CONTRACTS_DETAILS,
} from "constants/urls";

export default [
  {
    index: true,
    path: CONTRACT,
    lazy: () => import("modules/contract/pages/ContractDashboard"),
  },
  {
    path: CONTRACTS_DETAILS,
    lazy: () => import("modules/contract/pages/ContractDetails"),
  },
  {
    path: CONTRACT_DETAILS_TAB,
    lazy: () => import("modules/contract/pages/ContractDetails"),
  },
  {
    path: CONTRACT_SEND,
    lazy: () => import("modules/contract/pages/ContractSendEdit"),
  },
  {
    path: CONTRACT_EDIT,
    lazy: () => import("modules/contract/pages/ContractSendEdit"),
  },
] as RouteObject[];
